import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { Button, ProcessingButton } from "@qgiv/core-donor";

const ApplyPromoButton = ({ applyButtonLabel }) => {
    const { cms } = constants;
    // Needs to be called from inside the promo code form to ensure that the
    // isSubmitting value that is pulled is pulled from the parent context
    // associated with the promo code form instead of the outermost form
    const { isSubmitting } = useFormikContext();

    return isSubmitting ? (
        <ProcessingButton showBackground={false} />
    ) : (
        <Button
            type="submit"
            name="Apply_Promo"
            aria-label="Apply Promo Code"
            disabled={cms}
        >
            {applyButtonLabel}
        </Button>
    );
};

ApplyPromoButton.propTypes = {
    applyButtonLabel: PropTypes.string.isRequired,
};

export default ApplyPromoButton;
